module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("i68ZK"))).then(() => parcelRequire('5erN3'));